$ = jQuery
App =  {

	controller : false
	wHeight : false
	isMenuMoving : false
	color_darkBlue: "#262454",
	color_yellow: "#FFB900",
	
	init : ->
		console.log 'App init'
		
		# Init scrollMagic
		@controller = new ScrollMagic.Controller() ; 
		@wHeight = $(window).height()

		# Show grid for debug (dev only)
		@debugManager()

		# Shape animation
		@shapeManager()

		# Menus
		@menuManager()
		@mobileMenuManager()
		@headerMapManager()
		@menuStickyManager()


		# Tease Villa
		if $('.tease-villa').length
			@teaseVillaManager()
		
		# Zoom manager
		@zoomManager()

		# Smooth scroll for anchor
		@anchorManager()

		# Video asynchrone load
		@videoManager()

		# overlays
		@overlaysManager()

		# alert
		@alertManager()

	menuManager : ->

		_this = @

		$('.menu-big--grid').masonry({
			itemSelector: '.menu-big--block',
		})

		menusBigWrapper = $('.menus-big-wrapper')
		menusBigContainer = $('.menus-big-container')
		headercolorSave = $('#site-header .header--content').css('color')
		tlMenuOpen = false

		# Show circle on hover
		$('#site-header .nav--item').on "mouseenter", (ev) ->
			$(@).find('.circle-loader').addClass('hover')
		$('#site-header .nav--item').on "mouseleave", (ev) ->
			$(@).find('.circle-loader').removeClass('hover')

		# init menu close timeline
		
		console.log "INIT MENU"
		
		tlMenuClose = new TimelineLite({paused:true})
		tlMenuClose.addLabel('start')
			.to(menusBigContainer, 0.6, {y:'-110%',ease:Expo.easeInOut}, 'start')
			#.to($('#site-header .header--content'), 0.6, {color: headercolorSave, ease:Expo.easeInOut}, 'start')
			.to($('#site-header svg.arrow line'), 0.3, {stroke: headercolorSave, ease:Expo.easeIn}, 'start')
			.to($('#site-header .header--content .item-fontsize g'), 0.6, {fill: headercolorSave, stroke: 'transparent', ease:Expo.easeInOut}, 'start')
			.to($('#site-header .header--content .item-fontsize .tiret'), 0.6, {backgroundColor: headercolorSave, ease:Expo.easeInOut}, 'start')
			.to($('.menu-big--block'), 0.3,	{	y:-30, autoAlpha:0, ease:Quad.easeOut, force3D: true	}, 0.08)
			#.to($('#site-header .logo_yellow'), 0.6, {
		#		autoAlpha:0,
	#			ease:Expo.easeInOut
#				onComplete: _this.initMenu
			#},	'start')

		$('#site-header .nav--item').on "click", (ev) ->

			if not _this.isMenuMoving
				menuId = $(this).attr('data-open')
				if menuId != undefined and menu != false
					# Retrieve corresponding big menu
					menu = $('#'+menuId) ;
					if $(@).hasClass('active')
						$(@).removeClass('active')
						$('.menus-big-container').removeClass('active')
						$('.menu-big').removeClass('active')
						$("#site-header").removeClass('active')
						#$('.menus-big-wrapper').find('.overlay_close').css('pointer-events', 'none')
						console.log "close menu"
						tlMenuClose.restart()
					else
						$('#site-header .nav--item').removeClass('active')
						$(@).addClass('active')
						
						console.log "CLOSE MENU 1"
						
						$("#site-header").addClass('active')
						console.log 'not close menu'
						# If big menu container is not already open
						if not $('.menus-big-container').hasClass('active')
							menuFirstOpen(menu)
						else
							menuSwitch(menu)

		$('.menus-big-wrapper .overlay_close').on "click", (ev) ->
			$('#site-header .nav--item').removeClass('active')
			$('#site-header').removeClass('active')
			$('.menus-big-container').removeClass('active')
			$('.menu-big').removeClass('active')
			tlMenuClose.restart()
			
			console.log "OPEN MENU 2"
			

		menuFirstOpen = (menu) ->
			# switch class
					menusBigContainer.addClass('active')
					menu.addClass('active')
					$("#site-header").addClass('active')

					# Set container height to selected menu height, and reinit translate 
					TweenLite.set(menusBigContainer, {height: menu.outerHeight(), y:'-100%'})

					# Active overlay close
					#menusBigWrapper.find('.overlay_close').css('pointer-events', 'initial')

					_this.isMenuMoving = true

					console.log 'open menu first'
					# Menu Open Animation
					tlMenuOpen = new TimelineLite
					tlMenuOpen.addLabel('start')
						#.to($('#site-header .item-call'), 0.5, {color:App.color_darkBlue, ease:Expo.easeInOut}, 'start')
						.to($('#site-header svg.arrow line'), 0.3, {stroke:App.color_darkBlue, ease:Expo.easeIn}, 'start')
						#.to($('#site-header .nav--item.item-call'), 0.3, {color:App.color_yellow, borderColor: App.color_yellow, ease:Expo.easeIn}, 'start')
						.to($('#site-header .header--content .item-fontsize g'), 0.5, {fill:App.color_darkBlue, stroke:'transparent', ease:Expo.easeInOut}, 'start')
						.to($('#site-header .header--content .item-fontsize .tiret'), 0.5, {backgroundColor:App.color_darkBlue, ease:Expo.easeInOut}, 'start')
						#.to($('#site-header .logo_yellow'), 0.5, {autoAlpha:1, ease:Expo.easeInOut}, 'start')
						.to(menusBigContainer, 0.5, {y:'0%', ease:Expo.easeInOut}, 'start')
						.staggerFromTo(menu.find('.menu-big--block'), 0.3,
							{
								y:-30,
								autoAlpha:0
							},
							{
								y:0,
								autoAlpha:1,
								ease:Quad.easeOut,
								force3D: true
							}, 0.08, 'start+=0.6')

					if menu.attr('id') == 'menu-big_maisons'
						tlMenuOpen.fromTo(menu.find('.menu-big--map'), 0.6, {scale:0.95, autoAlpha: 0}, {scale:1, autoAlpha:1, ease:Expo.easeInOut, force3D: true}, '-=0.6')

					tlMenuOpen.add ->
						_this.isMenuMoving = false
						console.log "open complete"

		menuSwitch = (menu) ->
			console.log 'switch'

			$('.menu-big').removeClass('active')
			$("#site-header").removeClass('active')
			
			_this.isMenuMoving = true
			tlSwitchMenus = new TimelineLite
			tlSwitchMenus.addLabel('start')
				.to(['.menu-big--block', '.menu-big--map'], 0.6, {autoAlpha:0, y:-20, ease:Expo.easeIn})
				.to(menusBigContainer, 0.6, {height: menu.outerHeight(), ease:Expo.easeInOut})						
				.staggerFromTo(menu.find('.menu-big--block'), 0.3, {y:-30, autoAlpha:0}, {y:0, autoAlpha:1, force3D: true, ease:Quad.easeOut}, 0.08, '-=0.2')
			
			if menu.attr('id') == 'menu-big_maisons'
				tlSwitchMenus.fromTo(menu.find('.menu-big--map'), 0.6, {scale:0.95, autoAlpha: 0}, {scale:1, autoAlpha:1, ease:Expo.easeInOut, force3D: true}, '-=0.6')
			
			tlSwitchMenus.add ->
				_this.isMenuMoving = false
				console.log "switch complete"

			menu.addClass('active')
			$("#site-header").addClass('active')

	initMenu : ->
		console.log "_____ init menu ____"
		# switch class
		$('.menus-big-container').removeClass('active')
		$('.menu-big').removeClass('active')
		$('#site-header').removeClass('active')

		# Disable overlay close
		#$('.menus-big-wrapper').find('.overlay_close').css('pointer-events', 'none')

		# Hide big menu blocks
		TweenLite.set('.menu-big--block', {autoAlpha:0})
		TweenLite.set('.menu-big--map', {autoAlpha:0})

	headerMapManager : ->

		regionElt = $('.menu-big--block')
		mapSvg = $('.menu-big--map svg')

		regionElt.on "mouseenter", (ev) ->
			
			# Retrieve region Id
			regionId = $(@).attr('data-region')
			
			# Reset other regions bck color
			$.each mapSvg.find('path, polygon').not('#'+regionId), (i, elt) ->
				TweenLite.to(elt, 0.3, {fill: $(elt).attr('fill-save')})			

			# Change selected region bck color
			TweenLite.to(mapSvg.find('#'+regionId), 0.3, {fill: '#FEBF3E'})

			$(@).one "mouseleave", (ev) ->
				elt = mapSvg.find('#'+regionId)
				TweenLite.to(elt, 0.3, {fill: $(elt).attr('fill-save')})				


	menuStickyManager : ->

		# Smooth scroll on click 
		$('#nav-sticky .sticky--item').on "click", (ev) ->
			ev.preventDefault()

			$('#nav-sticky .sticky--item').removeClass('active');
			$(@).addClass('active');

			target = $( $(@).find('a').attr('href') )
			offset = $('.header--sticky').outerHeight()
			if parseInt(target.css('margin-top')) > 0
				offset += parseInt(target.css('margin-top'))
			TweenLite.to(window, 1.2, { scrollTo: {y: target, offsetY: offset}, ease:Quint.easeInOut })

		# Reveal sticky menu on scroll
		tween = TweenLite.to('.header--sticky', 0.5, {y:0, ease:Expo.easeOut})
		scene = new ScrollMagic.Scene({triggerElement: '#content', offset:@.wHeight, force3D:true})
			.setTween(tween)
			.addTo(@controller)
		# main menu sticky
		if(!$('#content').hasClass('page-villa') && !Config.isMobile())
			scene = new ScrollMagic.Scene({triggerElement: '#content', offset:@.wHeight, force3D:true})
				.setClassToggle('#content, #site-header', 'sticky-header')
				.addTo(@controller)


	mobileMenuManager : ->
		
		# Open / Close menu
		$('.item-burger-mobile').on "click", (ev) ->
			mobileOverlay = $('.block-menu-mobile')
			shadowOpacitySave = $('#site-header .shadow--down').css('opacity') 
			headercolorSave = $('#site-header .header--content').css('color')
			if mobileOverlay.hasClass('active')
				# allow scroll
				$('html').css('overflow', 'initial')
				$('body').css('overflow', 'initial')
				# remove class
				mobileOverlay.removeClass('active')
				$('.item-burger-mobile').removeClass('active')
				$('#site-header').removeClass('active')
				# Hide menu
				TweenLite.to(mobileOverlay, 0.6, {x:'100%', ease:Quint.easeInOut})
				# Switch header elements color
				#TweenLite.to $('#site-header .logo_yellow'), 0.3, {autoAlpha:0, ease:Expo.easeIn}
				TweenLite.to $('#site-header .item-burger-mobile svg g'), 0.3, {stroke:headercolorSave, ease:Expo.easeIn}
				# Show back header overlay

				TweenLite.to $('#site-header .shadow--down'), 0.3, {autoAlpha: shadowOpacitySave}
			else
				# disable scroll
				$('html').css('overflow', 'hidden')
				$('body').css('overflow', 'hidden')
				# add class
				mobileOverlay.addClass('active')
				$('.item-burger-mobile').addClass('active')
				$('#site-header').addClass('active')
				# Hide header overlay shadow
				TweenLite.to $('#site-header .shadow--down'), 0.3, {autoAlpha:0}
				# Switch header elements color
				# TweenLite.to $('#site-header .logo_yellow'), 0.3, {autoAlpha:1, ease:Expo.easeIn}
				TweenLite.to $('#site-header .item-burger-mobile svg g'), 0.3, {stroke:"#000", ease:Expo.easeIn}
				# Show menu
				TweenLite.to(mobileOverlay, 0.6, {x:'0%', ease:Quint.easeInOut})
				

		# Submenus manager
		$('#nav-mobile [has-accordeon]').on "click", (ev) ->
			accordeon = $(@).find('.accordeon-container')

			if $(@).hasClass('active')
				$("#nav-mobile .mobile--item").removeClass('active')
				$("#nav-mobile .mobile--item").removeClass('hidden')
				TweenLite.to(accordeon, 0.6, {height:0, ease:Quint.easeInOut})
			else
				
				$("#nav-mobile .mobile--item").removeClass('active').addClass("hidden")
				$(@).removeClass("hidden").addClass('active')
				TweenLite.set(accordeon, {height:"auto"})
				TweenLite.from(accordeon, 0.6, {height:0, ease:Quint.easeInOut})


	teaseVillaManager : ->

		_this = @

		if not Config.isMobile()

			$.each $('.tease-villa'), (i,teaseElt) ->

				titleElt = $(teaseElt).find('.tease-villa--content')
				
				# Sticky title on scroll
				scene = new ScrollMagic.Scene({triggerElement: titleElt[0], offset : titleElt.height()/2 , duration: _this.wHeight * 0.8 - titleElt.height(), force3D:true})
					.setPin(titleElt[0])
					.addTo(_this.controller)

				# Reveal shape on hover
				titleElt.on "mouseenter", (ev) ->

					_this = @

					shape = $(teaseElt).find('.shape-container')
					shape.addClass('active')

					setTimeout( ->
						$(_this).one "mouseleave", (ev) ->
							shape.removeClass('active')
					, 300)




	anchorManager : ->
		$('*[smooth-scroll]').on "click", (ev) ->
			ev.preventDefault()
			target = $( $(@).attr('href') )
			offset = 0
			if parseInt(target.css('margin-top')) > 0
				offset += parseInt(target.css('margin-top'))
			TweenLite.to(window, 1, { scrollTo: {y: target, offsetY: offset}, ease:Quint.easeInOut })


	videoManager : ->
		$.each $('.video--embed'), (i, elt) ->
			if not $(elt).hasClass 'custom'
				youtubeId = $(elt).attr('data-embed')

				$(elt).children('.cta-play-container').on "click", (ev) ->
					ev.preventDefault()
					ev.stopPropagation()
					iframe = document.createElement("iframe");
					iframe.setAttribute("frameborder", "0");
					iframe.setAttribute("allowfullscreen", "");
					iframe.setAttribute("src", "https://www.youtube.com/embed/" + youtubeId + "?rel=0&showinfo=0&autoplay=1")
					# elt.innerHTML = ""
					elt.appendChild(iframe)

	overlaysManager : ->

		# Show overlay
		$('[show-overlay]').on "click", (ev) ->
			overlay = $('.overlay-'+ $(@).attr('data-overlay'))
			tlShowOverlay = new TimelineLite
			tlShowOverlay.addLabel('start')
				.set(overlay, {autoAlpha:1})
				.fromTo(overlay, 0.8, {y:'-105%'}, {y:'0%', ease:Quint.easeInOut})

			# Hide overlay
			overlay.find('.cta_close').one "click", (ev) ->
				TweenLite.fromTo(overlay, 0.8, {y:'0%'}, {y:'105%', ease:Quint.easeInOut})
				TweenLite.set(overlay, {autoAlpha:0, delay: 0.8})

	alertManager : ->
		if $('.alert-container').length

			setTimeout ->
				TweenLite.fromTo $('.alert-container'), 0.8, {y:'-105%'}, {y:'0%', ease: Quint.easeInOut}
				TweenLite.to $('#content'), 0.8, {y:$('.alert-container').height(), ease: Quint.easeInOut, delay:0.05}

				$('.alert-container .cta_close').on "click", (ev) ->
					TweenLite.to $('#content'), 0.8, {y:0, ease: Quint.easeInOut}					
					TweenLite.fromTo $('.alert-container'), 0.8, {y:'0%'}, {y:'-105%', ease: Quint.easeInOut, delay:0.05}
			, 500

	zoomManager : ->
		baseFontsize = parseInt($('body').css('font-size'))

		$('.nav--item.item-fontsize').on "click", (ev) ->
			
			if $(@).hasClass 'active'
				$(@).removeClass 'active'
				TweenMax.to 'body', 0.5, { fontSize: baseFontsize, ease: Sine.easeOut, autoRound: false, force3D: true}
				TweenLite.to $(@), 0.3, {scale:1, ease:Quad.easeOut}
			else
				$(@).addClass 'active'
				TweenMax.to 'body', 0.5, { fontSize: baseFontsize*1.2, ease: Sine.easeOut, autoRound: false, force3D: true}
				TweenLite.to $(@), 0.3, {scale:1.2, ease:Quad.easeOut}


	shapeManager : ->

		_this = @

		$.each $('*[svg-anim]'), (i, elt) ->
			svg = $(elt).find('svg')[0];
			s = Snap(svg);
			startPath = s.select('.start');
			
			endPath = s.select('.end');

			startPoints = startPath.node.getAttribute('d');
			endPoints = endPath.node.getAttribute('d');

			_this.animatePath(startPath, startPoints, endPoints)

	animatePath : (path, startPoints, endPoints) ->
		toEnd = ->
				path.animate({ d: startPoints }, 5000, mina.quadout, toStart)

		toStart = ->
				path.animate({ d: endPoints }, 5000, mina.quadin, toEnd)

		toStart()


	debugManager : ->
		debugGrid = $('.wrapper').css('background-image')
		$('.wrapper').css('background-image', 'none')
		$('.overlay-fixed .overlay--container').css('background-image', 'none')
		$('.nav--list-container ul').css('background-image', 'none')
		
		$(window).keypress (ev) ->
			if ev.keyCode == 33
				if $('.wrapper').css('background-image') == 'none'
					$('.wrapper').css('background-image', debugGrid)
					$('.rappel--container').css('background-image', debugGrid)
				else
					$('.wrapper').css('background-image', 'none')
					$('.rappel--container').css('background-image', 'none')

	destroy : ->
		console.log "App destroy"
		
}